<template>
  <div class="tab-item-content">
    <div class="search-layout">
      <template v-if="!expanded">
        <div class="item-wrap long-big">
          <el-input
            size="small"
            placeholder="业务人员ID/业务人员手机号/真实姓名/身份证号/提现银行/银行卡号/银行预留手机号"
            v-model.trim="formRef.nameLike"
            clearable
          />
        </div>
      </template>
      <template v-else>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务人员ID"
            v-model.trim="formRef.salesJobNumber"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务员手机号"
            v-model.trim="formRef.contactInformation"
            clearable
          />
        </div>

        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="真实姓名"
            v-model.trim="formRef.truthName"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="身份证号"
            v-model.trim="formRef.agreeIc"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="银行卡号"
            v-model.trim="formRef.agreeBankCard"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-select
            v-model="formRef.status"
            placeholder="认证状态"
            size="small"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item-wrap long-small">
          <el-date-picker
            size="small"
            v-model="authenticationTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="认证时间-开始日期"
            end-placeholder="认证时间-结束日期"
            clearable
          >
          </el-date-picker>
        </div>
      </template>
      <div class="item-wrap op">
        <el-button size="small" @click="resetForm">重置</el-button>
        <el-button type="primary" size="small" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="text" size="small" @click="handleExpand()">
          {{ expanded ? "收起" : "展开"
          }}<i
            :class="{
              'el-icon-arrow-up': expanded,
              'el-icon-arrow-down': !expanded,
              'el-icon--right': true,
            }"
          ></i>
        </el-button>
      </div>
    </div>
    <div class="table-wrap">
      <MyTable
        :table-data="tableData"
        @sort-change="sortChange"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
      >
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import { queryAuthenticationInformation } from "@/api/externalSalesRule/index.js";
import dayjs from "dayjs";

export default {
  components: {
    MyTable,
  },
  data() {
    return {
      expanded: false,

      statusList: [
        { label: "签约失败", value: "-1" },
        { label: "待签约", value: "0" },
        { label: "待生成电子签", value: "1" },
        { label: "签约成功", value: "2" },
        { label: "待人工审核", value: "3" },
      ],

      authenticationTime: "",

      formRef: {
        nameLike: "", //业务人员ID/业务人员手机号/真实姓名/身份证号/银行卡号
        salesJobNumber: "", //业务员工号/就是页面上的业务员id
        contactInformation: "", //业务员手机号
        truthName: "", //真实姓名
        agreeIc: "", //	身份证号
        agreeBankCard: "", //	银行卡号
        status: "", //	状态：-1 签约失败; 0 待签约; 1 待生成电子签；2 签约成功;3 待人工审核（港澳台身份证返回）
        authenticationStartTime: "", //	认证时间-开始时间
        authenticationEndTime: "", //	认证时间-结束时间
        sortTag: "",
      },

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "业务人员ID", prop: "salesJobNumber", minWidth: 120 },
        { label: "业务人员手机号", prop: "contactInformation", minWidth: 120 },
        { label: "真实姓名", prop: "truthName", minWidth: 120 },
        {
          label: "身份证号",
          prop: "agreeIc",
          minWidth: 120,
        },
        {
          label: "银行卡号",
          prop: "agreeBankCard",
          minWidth: 120,
        },
        {
          label: "认证时间",
          prop: "authenticationTime",
          sortable: "custom",
          minWidth: 120,
          sortNum: 1,
        },
        {
          label: "状态",
          prop: "status",
          minWidth: 120,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleExpand() {
      this.expanded = !this.expanded;
    },
    currentChange(val) {
      console.log("current", val);
    },
    sortChange(val) {
      /**
       * 排序标识，1：认证时间正序，2：认证时间倒序
       */
      if (val.order) {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem && findedItem.sortNum) {
          if (val.order == "ascending") {
            ////升序
            this.formRef.sortTag = findedItem.sortNum;
          } else {
            this.formRef.sortTag = findedItem.sortNum + 1;
          }
        }
      } else {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem) {
          this.formRef.sortTag = "";
        }
      }
      this.getList();
    },
    getList() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        sortTag: this.formRef.sortTag,
      };
      //认证时间
      if (this.authenticationTime) {
        this.formRef.authenticationStartTime = dayjs(
          this.authenticationTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        this.formRef.authenticationEndTime = dayjs(
          this.authenticationTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
      }

      if (this.expanded) {
        _.merge(params, this.formRef);
        params.nameLike = "";
      } else {
        params.nameLike = this.formRef.nameLike;
      }

      queryAuthenticationInformation(params).then((data) => {
        if (data) {
          const { records, total } = data;
          this.page.total = total;
          this.tableData = records;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    resetForm() {
      let sortTag = this.formRef.sortTag;
      for (let key in this.formRef) {
        this.formRef[key] = "";
      }
      this.formRef.sortTag = sortTag;

      this.authenticationTime = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";

.statics {
  display: flex;
  flex-direction: row;

  .item {
    width: 120px;
    height: 80px;
    background: #f5222d;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:not(:first-child) {
      margin-left: 8px;
    }

    .tip {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
    }

    .value {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
      margin-top: 4px;
      max-width: 96%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
